var map = {
	"./Watertower_1.png": 1273,
	"./Watertower_2.png": 1274,
	"./Watertower_3.png": 1275,
	"./Watertower_4.png": 1276,
	"./Watertower_5.png": 1277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1272;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/watertower ^\.\/Watertower_.*\.png$
// module id = 1272
// module chunks = 3